import { RootState } from 'redux/reducers'
import { DownloadInfoProps, DownloadStatus } from 'redux/reducers/downloadReducer'

export const selectDownloadData = (
  state: RootState,
): {
  [key: string]: DownloadInfoProps
} => state.download.data

export const selectDownloadStatus = (state: RootState): DownloadStatus => state.download.status
